// extracted by mini-css-extract-plugin
module.exports = {"cell":"ContentCell_cell__1365l"};